import React from "react";
import { useLocale } from "@/context/LocaleContext";
import { useAuth } from "@/App";
import { persistUserPreferences } from "@/lib/persistUserPreferences";

const MATCHED_WIDTH_CLASS = "w-[8.75rem]";

/** Compact SV | EN toggle; language is stored in localStorage (no Mongo). */
export function LanguageSwitch({ className = "", matchedWidth = false }) {
  const { lang, setLang, t } = useLocale();
  const { user } = useAuth();

  const onPick = (next) => {
    setLang(next);
    if (user && user !== false) {
      persistUserPreferences({ preferred_lang: next }).catch(() => {});
    }
  };

  const btnBase =
    "flex-1 px-3 py-1.5 text-center transition-colors";

  return (
    <div
      className={`inline-flex rounded-lg border border-[var(--line-2)] overflow-hidden text-xs font-medium ${
        matchedWidth ? MATCHED_WIDTH_CLASS : ""
      } ${className}`}
      role="group"
      aria-label="Language"
    >
      <button
        type="button"
        data-testid="lang-sv"
        onClick={() => onPick("sv")}
        className={`${btnBase} ${
          lang === "sv"
            ? "bg-[var(--accent)] text-[var(--accent-foreground)]"
            : "bg-transparent text-[var(--text-dim)] hover:text-[var(--text)]"
        }`}
      >
        {t("lang.sv")}
      </button>
      <button
        type="button"
        data-testid="lang-en"
        onClick={() => onPick("en")}
        className={`${btnBase} ${
          lang === "en"
            ? "bg-[var(--accent)] text-[var(--accent-foreground)]"
            : "bg-transparent text-[var(--text-dim)] hover:text-[var(--text)]"
        }`}
      >
        {t("lang.en")}
      </button>
    </div>
  );
}
